const colors = ['red', 'yellow', 'blue'];
let arr = [];

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max + 1 - min) + min);
}

function animateDots() {
  if (window.innerWidth > 767 && arr.length) {
    const loop = () => {
      let dotIndexes = [];
      let speed = 300;

      if (window.innerWidth > 1024) {
        for (let i = 0; i <= 2; i += 1) {
          dotIndexes = [];
          dotIndexes.push(getRandomInt(0, arr.length - 1));

          speed = 300;
        }
      } else {
        for (let i = 0; i <= 1; i += 1) {
          dotIndexes = [];
          dotIndexes.push(getRandomInt(0, arr.length - 1));

          speed = 600;
        }
      }

      const colIndex = getRandomInt(0, colors.length - 1);

      dotIndexes.forEach((index, i) => {
        if (arr[index]) {
          arr[index].classList.add(colors[colIndex]);

          setTimeout(() => {
            if (arr[index]) {
              arr[index].classList.remove(colors[colIndex]);
            }
          }, 1200 + (i + 1) * 100);
        }
      });

      setTimeout(() => window.requestAnimationFrame(loop), speed);
    };

    window.requestAnimationFrame(loop);
  }
}

function fillInBackground(banner) {
  const cols = Math.ceil(banner.offsetWidth / 45);
  const rows = Math.ceil(banner.offsetHeight / 45);

  for (let i = 0; i < cols * rows; i += 1) {
    const cell = document.createElement('DIV');
    const dot = document.createElement('DIV');

    cell.classList.add('dot');
    cell.append(dot);

    banner.append(cell);

    arr.push(cell);
  }

  animateDots();
}

function clearBackground(banner) {
  banner.innerHTML = '';

  arr.forEach((item) => {
    if (item) {
      item.classList.remove('red');
      item.classList.remove('yellow');
      item.classList.remove('blue');
    }
  });

  arr = [];
}

function setMouseAnimation(event) {
  arr.forEach((item) => {
    const dot = item.querySelector('div');

    const rect = item.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    if (x >= 0 && y >= 0 && x < rect.width && y < rect.height) {
      dot.style.top = `${event.clientY - rect.top}px`;
      dot.style.left = `${event.clientX - rect.left}px`;
      dot.style.transform = 'translate(-50%, -50%) scale(2.2)';

      setTimeout(() => {
        dot.style.top = '50%';
        dot.style.left = '50%';
        dot.style.transform = '';
      }, 300);
    }
  });
}

export default function setHeroDecoration(className) {
  const banner = document.querySelector(className);
  if (!banner) return;

  window.addEventListener('load', () => {
    if (window.innerWidth > 767) {
      clearBackground(banner);
      fillInBackground(banner);
    } else {
      clearBackground(banner);
    }
  });

  window.addEventListener('mousemove', setMouseAnimation);

  window.addEventListener('resize', () => {
    if (window.innerWidth > 767) {
      clearBackground(banner);
      fillInBackground(banner);

      window.addEventListener('mousemove', setMouseAnimation);
    } else {
      clearBackground(banner);

      window.removeEventListener('mousemove', setMouseAnimation);
    }
  });
}
